import React, { Component } from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';

import scribe from '@grab-x/scribe-web-sdk';
import ScribeEventName from 'omega-rtc/constants/scribe';

import { Header, Modal, Button } from 'semantic-grab-ui';
import { Icon, Input } from 'grab-ui';
import type { StoreState } from 'reducers';
import type { UserState } from 'reducers/user';

import './FAQFeedbackForm.scss';

type Props = {
  closeModal: Function,
  faqInstance: Object,
  user: UserState,
};

const { TextArea } = Input;

class FAQFeedbackForm extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
      feedback: '',
      errors: {},
    };
  }

  handleFeedbackChange = (e) => {
    e.preventDefault();
    this.setState({ feedback: e.target.value });
  };

  validateFeedbackForm = () => {
    const feedback = this.state.feedback;
    const errorFlag = _.isEmpty(feedback);
    if (errorFlag) {
      this.setState({
        errors: {
          feedback: 'Please share more before submission',
        },
      });
    }
    return errorFlag;
  };

  handleSubmit = (e) => {
    if (this.validateFeedbackForm()) {
      return;
    }
    this.setState({ isLoading: true });
    const { faqInstance, closeModal, user } = this.props;
    // send scribe event.
    scribe.sendEvent(ScribeEventName.CAMPAIGN_METRICS, {
      type: 'faq_feedback',
      title: _.get(faqInstance, 'title'),
      email: _.get(user, 'email'),
      feedback: this.state.feedback,
    });

    setTimeout(() => {
      closeModal(e);
      this.setState({ isLoading: false });
    }, 1000);
  };

  render() {
    const { closeModal } = this.props;
    const { feedback, errors, isLoading } = this.state;
    const errorFeedback = _.get(errors, 'feedback');

    return (
      <Modal className={'faq-feedback-modal'} size={'small'} open>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <Header>
              Please share more
            </Header>
          </div>
          <div className={'close-modal'} onClick={closeModal}>
            <Icon color={'#707070'} type="close" style={{ fontSize: 21 }} />
          </div>
        </div>
        <Modal.Content>
          <div>
            <p>
              Thanks for letting us know!
              <span role="img" aria-label="Smiling Face">
               😊
              </span>{' '}
              To improve our suggestions, please tell us why it wasn&apos;t helpful.
            </p>
            <TextArea
              className={`feedback-input ${errorFeedback ? 'error' : ''}`}
              rows={6}
              value={feedback}
              onChange={this.handleFeedbackChange}
              placeholder="Type here"
              onBlur={this.validateFeedbackForm}
            />
            {errorFeedback && (
              <small className={'error-msg'}>{errorFeedback}</small>
            )}
          </div>
          <div className={'feedback-actions'}>
            <div className={'pull-left'} />
            <div className={'pull-right'}>
              <Button
                className={'skip-btn'}
                onClick={closeModal}
                disabled={isLoading}
              >
                Skip
              </Button>
              <Button
                className={'submit-btn'}
                onClick={this.handleSubmit}
                primary
                loading={isLoading}
                disabled={isLoading}
              >
                Submit
              </Button>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

function mapStateToProps(state: StoreState) {
  return {
    user: state.app.user,
  };
}

export default connect(mapStateToProps, {
})(FAQFeedbackForm);

